import React from 'react';

export default function Square({children,black}) {
    const fill = black ? 'black' : 'white';
    return <div style={{ width:60 }}>
        {children}
    </div>;
}